import { lazy, object, optional, Schema, string } from '../schema';
import { Address, addressSchema } from './address';

/**
 * Defines the fields that are included in the request body of a request
 * to the CreateCustomerCard endpoint.
 */
export interface CreateCustomerCardRequest {
  /**
   * A card nonce representing the credit card to link to the customer.
   * Card nonces are generated by the Square Payment Form when customers enter
   * their card information. See
   * [Embedding the payment form](https://developer.squareup.com/docs/payment-form/payment-form-walkthrough) for
   * more information.
   * __NOTE:__ Card nonces generated by digital wallets (e.g., Apple Pay)
   * cannot be used to create a customer card.
   */
  cardNonce: string;
  /** Represents a physical address. */
  billingAddress?: Address;
  /** The full name printed on the credit card. */
  cardholderName?: string;
  /**
   * An identifying token generated by `SqPaymentForm.verifyBuyer()`.
   * Verification tokens encapsulate customer device information and 3-D Secure
   * challenge results to indicate that Square has verified the buyer identity.
   */
  verificationToken?: string;
}

export const createCustomerCardRequestSchema: Schema<CreateCustomerCardRequest> = object(
  {
    cardNonce: ['card_nonce', string()],
    billingAddress: ['billing_address', optional(lazy(() => addressSchema))],
    cardholderName: ['cardholder_name', optional(string())],
    verificationToken: ['verification_token', optional(string())],
  }
);
